const formatMatchedString = (suggestion, search) => {
  const type = typeof suggestion;
  if (type === 'object' || type === 'string') {
    const s = search;
    const text = (suggestion.label) ? suggestion.label : suggestion;

    if (search.length > 0) {
      const re = new RegExp(`(${s.split(' ').join('|')})`, 'gi');
      return text.replace(re, '<em>$1</em>');
    }

    return text;
  }
  return '';
};

export default formatMatchedString;
